var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgDropOffManagement = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25.459,
    height: 25.459,
    viewBox: "0 0 25.459 25.459",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Drop-off_management",
    "data-name": "Drop-off management",
    transform: "translate(22503.982 7635.332)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "placeholder",
    transform: "translate(-22503.982 -7635.332)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7246",
    "data-name": "Group 7246",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7245",
    "data-name": "Group 7245"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5363",
    "data-name": "Path 5363",
    d: "M19.342,313.487a1.06,1.06,0,0,0-.489,2.063c3.295.782,4.489,1.938,4.489,2.526,0,1.268-4.23,3.182-10.608,3.182s-10.608-1.915-10.608-3.182c0-.588,1.2-1.744,4.488-2.526a1.06,1.06,0,0,0-.489-2.063C2.179,314.422,0,316.052,0,318.076c0,3.482,6.405,5.3,12.729,5.3s12.729-1.822,12.729-5.3C25.464,316.052,23.29,314.422,19.342,313.487Z",
    transform: "translate(-0.005 -297.92)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5365",
    "data-name": "Path 5365",
    d: "M112.73,20.767l.432.863a1.062,1.062,0,0,0,1.9,0l.914-1.829a73.4,73.4,0,0,1,3.812-6.469l.6-.952a7.424,7.424,0,0,0-7.149-11.33,7.419,7.419,0,0,0-5.115,11.767A53.371,53.371,0,0,1,112.73,20.767Zm1.381-15.523a3.182,3.182,0,1,1-3.182,3.182A3.186,3.186,0,0,1,114.112,5.244Z",
    transform: "translate(-101.382 -1)",
    fill: "#fff"
  })))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDropOffManagement, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Drop-offManagement.e37a8355.svg";
export { ForwardRef as ReactComponent };